import base from "@/store/utils/api-route/base";

const api = {
    list: `${base.masterData}keuangan/list_setoran_workshop`,
    detail: `${base.masterData}keuangan/detail_setoran_workshop`,
    confirm: `${base.masterData}keuangan/konfirmasi_setoran_workshop`,
    delete: `${base.masterData}keuangan/delete_setoran_dana`,
};

export default api;
